module.exports = __webpack_public_path__ + "img/stopwatch-alt.736b0dca.svg";